const colors = {
  bodyColor: '#fafafa',
  contentBackground: '#ffffff',
  textColor: '#282828',
  textLightColor: '#636769',
  textVeryLightColor: '#c0c0c0',
  placeholderColor: '#949494',
  inverseTextColor: '#FFFFFF',
  fieldTextColor: '#6D6D6D',
  disabledTextColor: '#a5acb1',
  linkColor: '#0a58cc',
  visitedLinkColor: '#89579b',
  headerTitleColor: '#003479',
  messageNotificationBackground: '#EAF0F7',
  successBackground: '#00B38A',
  warningBackground: '#EA7125',
  warningBackgroundColor: '#dfcbb1',
  softHighlightedBackgroundColor: '#f9f9f9',
  fieldOutlineColor: '#e5e5e5',
  oddTableRowBackground: '#f9f9f9',
  greyBackground3: '#f7f7f8',
  notificationBackground: '#EFFFDF',
  interruptionNotificationBackground: '#f5ffec',
  disabledBackgroundColor: '#DFDFDF',
  errorBackgroundColor: '#FFE5E5',
  outlineColor: '#F1F1F1',
  outlineShadowColor: '#A7A7A7',
  greenShadowColor: '#53811D',
  horizontalRuleColor: '#E7E7E7',
  pendingItemColor: '#FFAF34',
  pendingItemBackground: '#fffaf2',
  errorItemColor: '#c33932',
  suomifiErrorColor: '#C13832',
  hoverColor: '#E4F3D4',
  additionalInfoBackground: '#FDFDFD',
  additionalInfoBorder: '#DFDFDF',
  infoBackground: '#eaf0f7',
  infoBorder: '#b0d0e8',
  infoBackgroundColor: '#eaf8fc',
  summaryBackground: '#FAFAFA',
  summaryBorder: '#D3D1D1',
  infoBlue: '#34B6E4',
  actionBlue: '#2A6EBB',
  actionBlueHover: '#4387D5',
  disabledButton: '#c9cdcf',
  disabledInputBorder: '#c8cdd0',
  inputBorder: '#8C969B',
  greyBorder: '#E3E7EB',
  warningYellow: '#F4AA00',
  okGreen: '#02B38B',
  boxBorder: '#E3E7EB',
  buttonOutline: '#FFFFFF',
  maistraattiBackground: '#f6f6f6',
  maistraattiFadedText: '#D3D3D3',
  maistraattiLightText: '#9B9B9B',
  maistraattiBoldText: '#464646',
  maistraattiTextOnGrayBackground: '#000000',
  maistraattiBorderColor: '#979797',
  maistraattiLightBackground: '#e9f0f8',
  applyNimenmuutosContainerBackgroundColor: '#f7fafd',
  nimenmuutosPriceListHeaderTextColor: '#292929',
  tableOddRowColor: '#fafafa',
  tableEvenRowColor: '#ffffff',
  tableBorderColor: '#ced2d5',
  borderColor: '#CED2D5',
}

export default colors
